import { useGetUmbracoTafDeliveryApiV1ContentGlobalSiteSettingsSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/content/content.ts';

const useGetGlobalSiteSettings = () => {
    const { data } = useGetUmbracoTafDeliveryApiV1ContentGlobalSiteSettingsSuspense();
    return data;
};

export default useGetGlobalSiteSettings;
